import * as types from 'apa/actions/types'

const initialState = {
  token: localStorage.getItem('token'),
  isAuthenticated: false,
  isLoading: true,
  user: null,
  errors: {},
  isOnline: true,
  isSuperUser: false,
  messageList: []
}


export default function apa(state = initialState, action) {
  switch (action.type) {
    case types.USER_LOADING:
      return { ...state, isLoading: true }
    case types.CANCEL_USER_LOAD:
      return { ...state, isLoading: false }
    case types.USER_LOADED:
      return { ...state, isAuthenticated: true, isLoading: false, user: action.user, isSuperUser: action.user.is_superuser}
    case types.USER_LOADED_ERROR:
      return { ...state, isLoading: false }
    case types.LOGIN_SUCCESSFUL:
      localStorage.setItem('token', action.data.token)
      return { ...state, token: action.data.token, user: action.data.user, isAuthenticated: true, isLoading: false, errors: {}, isSuperUser: action.data.user.is_superuser}
    case types.AUTHENTICATION_ERROR:
    case types.LOGIN_FAILED:
      return { ...state, errors: action.errors, isAuthenticated: false, isLoading: false }
    case types.LOGOUT_SUCCESSFUL:
      localStorage.removeItem('token')
      return { ...state, token: null, user: null, isAuthenticated: false, isLoading: false }
    case types.API_ERROR:
      return { ...state, errors: action.errors, isOnline: false }
    case types.API_SUCCESS:
      return { ...state, isOnline: true }
    case types.API_ACCESS_DENIED:
      return { ...state, isAuthenticated: false, user: null, isLoading: false }
    case types.NEW_MESSAGE:
      return {...state, messageList: [...state.messageList, action.message]}
    default:
      return state
  }
}
